function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
// import clone from 'ramda/src/clone';
// import compose from 'ramda/src/compose';
// import flatten from 'ramda/src/flatten';
// import pathOr from 'ramda/src/pathOr';
// import pluck from 'ramda/src/pluck';
// import prop from 'ramda/src/prop';
// import sortBy from 'ramda/src/sortBy';
// import uniq from 'ramda/src/uniq';
// import filter from 'ramda/src/filter';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import { MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { ALL_STEPS_KEYS } from '../constants/add.offer.wizard.constants';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import {
// CartAdditionalPropertyFieldsSelector,
OfferAdditionalPropertyFieldsSelector, OrderAdditionalPropertyFieldsSelector } from 'invision-core/src/components/metadata/codes/codes.additional.properties.selectors';
import { OfferingMetadataByIdSelector, OfferingMetadataProductsSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
// import {ShippingMethodsSelector} from 'invision-core/src/components/metadata/shippingMethods/shipping.methods.selectors';
// import {CurrentCustomerCurrencyCodeSelector} from './customer.selectors';
import CareLocaleKeys from '../../locales/keys';
import {
// AvailableCreditFromQuote,
BillCycle, BillingAddressStateRegionProvinceValueOptions, Cart,
// DeliveryMethodOptionsSelector,
// DeliveryOptionsByPricingPlanHelper,
EditOption, EditOptions, EditCart, EditSelectedFacetIds, EditSelectedOfferId,
// FinanceCreditFromQuoteSelector,
FormattedAttributes,
// FormattedDeliveryDecisions,
// FormattedPhysicalAttributes,
GetAdditionalPropertyListMapSelector,
// GetCartAdditionalPropertiesSelector,
// GetDownPaymentTypeValue,
// GetOfferingOrderQuoteSelector,
// GetOfferQuoteSelector,
GetOfferAdditionalPropertiesSelector, GetOrderAdditionalPropertiesSelector,
// GetPostQuoteDueTotalsSelector,
// GetPreQuoteDueSubTotalsSelector,
// GetQuoteHasInvoiceItemsSelector,
// GetTotalDownPaymentAmountSelector,
// InventoryAvailabilityRequests,
// IsCreditLimitBreachedFromQuote,
// OfferingOrderOffCycleAlignmentOptionsSelector,
// OfferingOrderProductIdsAndPricingPlanIdsOffCycleOfferSelector,
PaymentInfo, SelectedEditOption,
// SelectedOffCycleAlignmentsSelector,
SelectedOfferId, ServiceAddress
// ShippingAddressWizardSelector,
// TaxLocationDecisionsByPricingPlanHelper
} from '../helpers/offer.ordering.wizard.selector.helper';
import { CompletedSteps, CurrentStep, CurrentStepIndex, CurrentStepIsInvalid, FormattedAddressCityState, IsActiveStep,
// SelectedTabIndex,
SkippedStep
// TabPanelViewModel
} from '../helpers/wizard.selector.helper';
// import {SubscriptionQuoteForPreview} from './products.order.selectors.helper';
// import {SelectedPaymentMethodSelector} from './customer.ewallet.selectors';
// import {
//     isValidPaymentInstrument,
//     isValidBillingInformation
// } from '../../utilities/payment.instrument.helper';
// import {ASYNC_STATUS_CONSTANTS} from '../constants/wizard.constants';
// import {
//     getFinanceItems,
//     getUniqueNonGuidServiceIdentifiers
// } from '../helpers/add.offer.wizard.selectors.helpers';
import {
// FilteredStoresOnSelectedRegionForStoresSearchModalSelector,
// generateKeyFromInventoryItem,
// HasOffCycleChargeRenewalSelector,
// InventoryAvailabilitySelector,
// PaymentInstrumentRequiredSelector,
// SelectedOfferingPhysicalInventoriesSelector,
// SelectedOfferPurchaseOrderNumberSelector,
ShoppingCartSelector } from './selected.offering.order.selectors';
import { EMPTY_ARRAY
// EMPTY_OBJECT
} from '../constants/common.constants';
import { GROUP_TEMPLATE_ID } from '../constants/add.services.wizard.constants';
// import {
//     AsyncStatusSelector,
//     FullCartAsyncStatusSelector,
//     InventoryRegionFilterSelector,
//     OfferingOrderDataSelector,
//     OfferingOrderFinanceCreditLimitSelector,
//     OfferingOrderOffCycleAlignmentSelector,
//     OfferingOrderQuoteSelector,
//     SelectedInventoryRegionSelector,
//     SelectedInventoryStoresSelector,
//     SelectedOrderExecutionOptionsSelector
// } from './offering.order.selectors';
// import {BILLER_RULE_CYCLE_LEVEL} from '../../customercare.constants';
import { getFormattedServiceAttributeValue } from './services.list.selectors.helper';
import { TAX_RULE_OPTIONS } from '../../customercare.constants';
import { getServiceIdentifierAttribute } from './add.services.wizard.selectors.helper';
var AddServicesWizardStoreSelector = function AddServicesWizardStoreSelector(state) {
  return state.customercare.recoverableUiState.addServicesWizard;
};
var CartSelector = Cart([AddServicesWizardStoreSelector]);
export var CurrentStepIndexSelector = CurrentStepIndex([AddServicesWizardStoreSelector]);
export var CurrentStepSelector = CurrentStep([CurrentStepIndexSelector], ALL_STEPS_KEYS);
export var IsOffersStepSelector = IsActiveStep([CurrentStepSelector], ALL_STEPS_KEYS, 0);
export var IsDecisionsStepSelector = IsActiveStep([CurrentStepSelector], ALL_STEPS_KEYS, 1);
export var IsAttributesStepSelector = IsActiveStep([CurrentStepSelector], ALL_STEPS_KEYS, 2);
export var IsCheckoutStepSelector = IsActiveStep([CurrentStepSelector], ALL_STEPS_KEYS, 3);
export var CompletedStepsSelector = CompletedSteps([AddServicesWizardStoreSelector]);
export var EditCartSelector = EditCart([AddServicesWizardStoreSelector]);
var SelectedEditOptionSelector = SelectedEditOption([EditCartSelector]);
export var BillCycleSelector = BillCycle([EditCartSelector]);
export var EditOptionsSelector = EditOptions([EditCartSelector]);
export var EditOptionSelector = EditOption([SelectedEditOptionSelector, EditOptionsSelector]);
export var EditSelectedFacetIdsSelector = EditSelectedFacetIds([EditCartSelector]);
export var EditSelectedOfferIdSelector = EditSelectedOfferId([EditCartSelector]);
export var ServiceAddressSelector = ServiceAddress([AddServicesWizardStoreSelector]);
export var PaymentInfoSelector = PaymentInfo([CartSelector]);
export var PaymentInfoEditSelector = PaymentInfo([EditCartSelector]);
export var BillingAddressStateRegionProvinceValueOptionsSelector = BillingAddressStateRegionProvinceValueOptions([PaymentInfoEditSelector, MetadataCodeTypeSelector(CODES.AddressCountry), MetadataCodeTypeSelector(CODES.AddressStateProvinceRegion)]);
export var SkippedStepSelector = SkippedStep([AddServicesWizardStoreSelector]);
export var CurrentStepIsInvalidSelector = CurrentStepIsInvalid([AddServicesWizardStoreSelector]);
export var SelectedOfferIdSelector = SelectedOfferId([CartSelector]);

// export const SelectedTabIndexSelector = SelectedTabIndex([AddServicesWizardStoreSelector]);

// export const TabPanelViewModelSelector = TabPanelViewModel([SelectedTabIndexSelector]);

export var FormattedAttributesSelector = FormattedAttributes([EditCartSelector]);
// export const FormattedPhysicalAttributesSelector = FormattedPhysicalAttributes([EditCartSelector, SelectedOfferIdSelector, SelectedInventoryStoresSelector]);
// export const InventoryAvailabilityRequestsSelector = InventoryAvailabilityRequests([FormattedPhysicalAttributesSelector, EditCartSelector]);

export var FormattedCityStateSelector = FormattedAddressCityState([ServiceAddressSelector]);
export var AddServicesOrderDataSelector = createSelector([AddServicesWizardStoreSelector], function (addServicesWizardStore) {
  return addServicesWizardStore.data;
});
export var FormValidationStatusesSelector = createImmutableSelector([AddServicesWizardStoreSelector], function (addServicesWizardStore) {
  return addServicesWizardStore.attributesValidationStatuses;
});
export var AttributesFormSubmittedSelector = createImmutableSelector([AddServicesWizardStoreSelector], function (addServicesWizardStore) {
  return addServicesWizardStore.attributesFormSubmitted;
});

// export const ChangeOfferingInstanceIdSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.changeOfferingInstanceId;
//     }
// );

// export const ChangeOfferingIdSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.changeOfferingId;
//     }
// );

export var EditSelectedOfferingChargeTypeIdSelector = createSelector([EditCartSelector], function (editCart) {
  return editCart.selectedOfferingChargeTypeIds;
});

// const EMPTY_ATTRIBUTE_GROUPS = Immutable([]);
// export const EditAttributeGroupsSelector = createSelector(
//     [EditCartSelector],
//     (editCart) => {
//         return editCart.editAttributeGroups ? editCart.editAttributeGroups.asMutable({
//             deep: true
//         }) : EMPTY_ATTRIBUTE_GROUPS;
//     }
// );

export var SelectedServiceTemplateIdSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.selectedServiceTemplateId;
});
export var IsGroupTemplateConfiguredSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.isGroupTemplateConfigured;
});
export var GroupTemplateSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.groupTemplate;
});
var ValueDecisionsSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.serviceAttributeFields;
});
var ServiceTemplateMap = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.serviceTemplateMap;
});
var ServiceTemplateMapSelector = createImmutableSelector([ValueDecisionsSelector, ServiceTemplateMap, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (valueDecisions, serviceTemplateMap, serviceAttributes, regularExpressions) {
  return Object.entries(serviceTemplateMap).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      templateId = _ref2[0],
      serviceTemplate = _ref2[1];
    var serviceIdentifierAttribute = getServiceIdentifierAttribute(valueDecisions, serviceTemplate);
    var formattedName = serviceIdentifierAttribute && serviceTemplate.attributes[serviceIdentifierAttribute.ServiceAttributeId] && getFormattedServiceAttributeValue(serviceIdentifierAttribute.ServiceAttributeId, serviceTemplate.attributes[serviceIdentifierAttribute.ServiceAttributeId], serviceAttributes, regularExpressions);
    accumulator[templateId] = _objectSpread(_objectSpread(_objectSpread({}, serviceTemplate), serviceIdentifierAttribute.ServiceAttributeId ? {
      serviceIdentifierAttributeId: serviceIdentifierAttribute.ServiceAttributeId
    } : {}), {}, {
      title: formattedName || serviceTemplate.title
    });
    return accumulator;
  }, {});
});
var SelectedServiceIdentifierValueDecisionSelector = createImmutableSelector([ValueDecisionsSelector, ServiceTemplateMapSelector, SelectedServiceTemplateIdSelector], function (valueDecisions, serviceTemplateMap, selectedServiceTemplateId) {
  return getServiceIdentifierAttribute(valueDecisions, serviceTemplateMap[selectedServiceTemplateId]);
});
var SelectedServiceTemplateServiceIdentifierSelector = createImmutableSelector([SelectedServiceIdentifierValueDecisionSelector], function (serviceIdentifierValueDecisions) {
  return serviceIdentifierValueDecisions && serviceIdentifierValueDecisions.ServiceAttributeId;
});
function getOverriddenProps(groupTemplate, serviceTemplate, serviceIdentifier) {
  return Object.keys(serviceTemplate.attributes).reduce(function (serviceAttributeIds, serviceAttributeId) {
    if (serviceIdentifier !== serviceAttributeId) {
      var groupValue = groupTemplate.attributes[serviceAttributeId];
      var serviceValue = serviceTemplate.attributes[serviceAttributeId];
      if (serviceValue && !groupValue || serviceValue && groupValue && serviceValue !== groupValue) {
        serviceAttributeIds.push(serviceAttributeId);
      }
    }
    return serviceAttributeIds;
  }, []);
}
export var SelectedServiceFeaturesSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.selectedServiceFeatures;
});
export var SelectedServiceTemplateDetailsSelector = createImmutableSelector([SelectedServiceTemplateIdSelector, GroupTemplateSelector, ServiceTemplateMapSelector], function (selectedServiceTemplateId, groupTemplate, serviceTemplateMap) {
  if (selectedServiceTemplateId === GROUP_TEMPLATE_ID) {
    return groupTemplate;
  } else {
    var serviceTemplate = serviceTemplateMap[selectedServiceTemplateId];
    var overriddenProps = getOverriddenProps(groupTemplate, serviceTemplate, serviceTemplate.serviceIdentifierAttributeId);
    return _objectSpread(_objectSpread({}, serviceTemplate), {}, {
      overriddenProps: overriddenProps
    });
  }
});
export var ServiceTemplatesSelector = createImmutableSelector([ServiceTemplateMapSelector], function (serviceTemplateMap) {
  return Object.values(serviceTemplateMap);
});
export var IsGroupTemplateSelectedSelector = createImmutableSelector([SelectedServiceTemplateIdSelector], function (selectedServiceTemplateId) {
  return selectedServiceTemplateId === GROUP_TEMPLATE_ID;
});
export var AllServiceAttributeFieldsSelector = createImmutableSelector([ValueDecisionsSelector, SelectedServiceTemplateDetailsSelector, GroupTemplateSelector], function (valueDecisions, selectedServiceTemplateDetails, groupTemplate) {
  var fieldsMap = valueDecisions.reduce(function (acc, attribute) {
    var isFieldHidden = false;
    if (attribute.DependentServiceAttributeId && attribute.DependentValues) {
      var dependentValues = attribute.DependentValues.split(',');
      var dependentAttributeId = attribute.DependentServiceAttributeId.split('-')[2];
      var selectedDependentValue = dependentAttributeId && (selectedServiceTemplateDetails.attributes[dependentAttributeId] || groupTemplate.attributes[dependentAttributeId]);
      if (!selectedDependentValue || !dependentValues.includes(selectedDependentValue)) {
        isFieldHidden = true;
      }
    }
    acc[attribute.ServiceAttributeId] = _objectSpread(_objectSpread({}, attribute), {}, {
      isFieldHidden: isFieldHidden
    });
    return acc;
  }, {});
  return Object.values(fieldsMap);
});
export var ServiceIdentifierDependantAttributeSelector = createImmutableSelector([AllServiceAttributeFieldsSelector], function (serviceAttributes) {
  var _find;
  var ServiceIdentifierDependantAttributeId = ((_find = (serviceAttributes || []).find(function (serviceAttribute) {
    return !!serviceAttribute.DependentServiceAttributeId && serviceAttribute.ServiceIdentifierFlag;
  })) === null || _find === void 0 ? void 0 : _find.DependentServiceAttributeId) || null;
  return ServiceIdentifierDependantAttributeId ? (serviceAttributes || []).find(function (serviceAttribute) {
    return serviceAttribute.Id === ServiceIdentifierDependantAttributeId;
  }) : null;
});
var GroupTemplateServiceAttributeFieldsSelector = createImmutableSelector([AllServiceAttributeFieldsSelector, ServiceIdentifierDependantAttributeSelector], function (allServiceAttributeFields, serviceIdentifierDependantAttribute) {
  return allServiceAttributeFields.filter(function (serviceAttribute) {
    return !serviceAttribute.ServiceIdentifierFlag && serviceAttribute.ServiceAttributeId !== (serviceIdentifierDependantAttribute === null || serviceIdentifierDependantAttribute === void 0 ? void 0 : serviceIdentifierDependantAttribute.ServiceAttributeId);
  });
});
export var SelectedServiceTemplateFieldsSelector = createImmutableSelector([SelectedServiceTemplateIdSelector, GroupTemplateServiceAttributeFieldsSelector, AllServiceAttributeFieldsSelector], function (selectedServiceTemplateId, groupTemplateFields, serviceTemplateFields) {
  if (selectedServiceTemplateId === GROUP_TEMPLATE_ID) {
    return groupTemplateFields;
  } else {
    return serviceTemplateFields;
  }
});
function hasOverriddenProps(groupTemplate, serviceTemplate, groupTemplateFields) {
  var groupTemplateAttributeIds = (groupTemplateFields || []).map(function (attribute) {
    return attribute.ServiceAttributeId;
  });
  return groupTemplateAttributeIds.some(function (serviceAttributeId) {
    var groupValue = groupTemplate.attributes[serviceAttributeId];
    var serviceValue = serviceTemplate.attributes[serviceAttributeId];
    return serviceValue && !groupValue || serviceValue && groupValue && serviceValue !== groupValue;
  });
}
export var SubmittedOrderErrorSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.lastAttemptError;
});
var DuplicateSerivceIdentifiersFromServerSelector = createImmutableSelector([SubmittedOrderErrorSelector], function (lastSubmitError) {
  var duplicatesFromServer = [];
  if (lastSubmitError && lastSubmitError.contextData && lastSubmitError.contextData.length) {
    var duplicateServiceIdentifiers = lastSubmitError.contextData.find(function (data) {
      return data.Key === 'ServiceIdentifiers';
    });
    if (duplicateServiceIdentifiers) {
      duplicatesFromServer = duplicateServiceIdentifiers.Value.split(',');
    }
  }
  return duplicatesFromServer;
});
export var DuplicateServiceIdentifiersSelector = createImmutableSelector([ServiceTemplatesSelector, DuplicateSerivceIdentifiersFromServerSelector], function (serviceTemplates, duplicatesFromServer) {
  var duplicates = [];
  var serviceIdentifierMap = new Map();
  _toConsumableArray(serviceTemplates).forEach(function (template) {
    var serviceIdentifierValue = template.attributes[template.serviceIdentifierAttributeId];
    if (!serviceIdentifierMap.has(serviceIdentifierValue)) {
      serviceIdentifierMap.set(serviceIdentifierValue, serviceIdentifierValue);
    } else {
      duplicates.push(serviceIdentifierValue);
    }
  });
  duplicatesFromServer.forEach(function (duplicate) {
    if (!duplicates.includes(duplicate) && serviceIdentifierMap.has(duplicate)) {
      duplicates.push(duplicate);
    }
  });
  return duplicates;
});
export var AllServiceTemplatesSelector = createImmutableSelector([GroupTemplateSelector, ServiceTemplatesSelector, SelectedServiceTemplateIdSelector, GroupTemplateServiceAttributeFieldsSelector, DuplicateServiceIdentifiersSelector, DuplicateSerivceIdentifiersFromServerSelector, FormValidationStatusesSelector, AttributesFormSubmittedSelector], function (groupTemplate, serviceTemplates, selectedServiceTemplateId, groupTemplateFields, duplicates, duplicatesFromServer, validationStatuses, formSubmitted) {
  return [groupTemplate].concat(_toConsumableArray(serviceTemplates)).map(function (serviceTemplate) {
    var overridden = hasOverriddenProps(groupTemplate, serviceTemplate, groupTemplateFields);
    var serviceIdentifierValue = serviceTemplate.attributes[serviceTemplate.serviceIdentifierAttributeId];
    var isDuplicate = serviceIdentifierValue !== undefined && (duplicates.includes(serviceIdentifierValue) || duplicatesFromServer.includes(serviceIdentifierValue));
    var validationStatus = Object.keys(validationStatuses).length ? validationStatuses[serviceTemplate.Id] : null;
    return _objectSpread(_objectSpread({}, serviceTemplate), {}, {
      glyph: overridden ? 'override' : null,
      glyphText: i18n.translate(CareLocaleKeys.ORDER_SETTINGS_HAVE_BEEN_OVERRIDDEN),
      hasError: formSubmitted && (isDuplicate || validationStatus && !validationStatus.isValid),
      selected: serviceTemplate.Id === selectedServiceTemplateId
    });
  });
});
export var HasServiceFeaturesAvailableSelector = createImmutableSelector([AllServiceAttributeFieldsSelector], function (attributeFields) {
  return (attributeFields || []).some(function (attribute) {
    return attribute.ServiceIdentifierFlag && attribute.IsServiceFeatureAvailable;
  });
});
export var IsSelectedServiceTemplateServiceIdentifierValueDuplicateSelector = createImmutableSelector([DuplicateServiceIdentifiersSelector, SelectedServiceTemplateDetailsSelector, SelectedServiceTemplateServiceIdentifierSelector, DuplicateSerivceIdentifiersFromServerSelector], function (duplicates, selectedServiceTemplate, serviceIdentifierKey, duplicatesFromServer) {
  return (duplicates || []).includes(selectedServiceTemplate.attributes[serviceIdentifierKey]) || duplicatesFromServer.includes(selectedServiceTemplate.attributes[serviceIdentifierKey]);
});
export var SummaryTabViewModelSelector = createImmutableSelector([ShoppingCartSelector, ServiceTemplatesSelector, OfferingMetadataByIdSelector, OfferingMetadataProductsSelector, OfferingMetadataPricingPlansSelector], function (shoppingCart, serviceTemplates, offeringMetadata, productMetadata, pricingPlanMetadata) {
  var offers = (shoppingCart.Items || []).reduce(function (viewModel, _ref3) {
    var OfferingId = _ref3.OfferingId,
      ProductId = _ref3.ProductId,
      PricingPlanId = _ref3.PricingPlanId;
    if (!viewModel[OfferingId]) {
      viewModel[OfferingId] = {
        Id: OfferingId,
        DisplayName: offeringMetadata[OfferingId].DisplayName,
        Products: {}
      };
    }
    if (!viewModel[OfferingId].Products[ProductId]) {
      viewModel[OfferingId].Products[ProductId] = {
        Id: ProductId,
        DisplayName: productMetadata[ProductId].Name,
        PricingPlans: {}
      };
    }
    if (!viewModel[OfferingId].Products[ProductId].PricingPlans[PricingPlanId]) {
      viewModel[OfferingId].Products[ProductId].PricingPlans[PricingPlanId] = {
        Id: PricingPlanId,
        DisplayName: pricingPlanMetadata[PricingPlanId].Name
      };
    }
    return viewModel;
  }, {});
  var services = serviceTemplates.map(function (serviceTemplate) {
    return serviceTemplate.title;
  });
  return {
    offers: offers,
    services: services
  };
});
export var IsSubmittingOrderSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.isSubmittingOrder;
});
export var IsShoppingCartContainsOnlyServiceIndependentItemsSelector = createImmutableSelector([ShoppingCartSelector], function (shoppingCart) {
  return (shoppingCart.Items || []).every(function (_ref4) {
    var IsServiceIndependent = _ref4.Details.PricingPlan.IsServiceIndependent;
    return IsServiceIndependent;
  });
});

// export const DeliveryDecisionsSelector = createImmutableSelector(
//     [EditCartSelector],
//     (editCart) => {
//         return editCart.deliveryDecisions || EMPTY_ARRAY;
//     }
// );

var ServiceTaxDecisionsSelector = createImmutableSelector([EditCartSelector], function (editCart) {
  return editCart.serviceTaxDecisions || EMPTY_ARRAY;
});
export var DefaultServiceTaxDecisionsSelector = createImmutableSelector([ServiceTaxDecisionsSelector, SelectedServiceIdentifierValueDecisionSelector], function (serviceTaxDecisions, serviceIdentifierValueDecision) {
  return serviceTaxDecisions.find(function (taxDecision) {
    return taxDecision.PricingPanId === serviceIdentifierValueDecision.PricingPanId;
  });
});
export var TaxLocationByPricingPlanSelector = createImmutableSelector([DefaultServiceTaxDecisionsSelector, ServiceTemplateMapSelector], function (defaultTaxDecisions, serverTemplateMap) {
  if (defaultTaxDecisions) {
    var taxLocationMapByPricingPlan = _defineProperty({}, defaultTaxDecisions.PricingPlanId, {});
    Object.entries(serverTemplateMap).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];
      taxLocationMapByPricingPlan[defaultTaxDecisions.PricingPlanId] = _objectSpread(_objectSpread({}, taxLocationMapByPricingPlan[defaultTaxDecisions.PricingPlanId]), {}, _defineProperty({}, key, {
        ServiceTaxCustomization: value.taxLocation || {},
        taxOption: value.taxLocation ? TAX_RULE_OPTIONS.CUSTOM : TAX_RULE_OPTIONS.DEFAULT
      }));
    });
    return taxLocationMapByPricingPlan;
  }
});

// export const DeliveryOptionsByPricingPlanSelector = DeliveryOptionsByPricingPlanHelper([DeliveryDecisionsSelector, ShippingMethodsSelector]);

// export const FormattedDeliveryDecisionsSelector = FormattedDeliveryDecisions([DeliveryDecisionsSelector]);

// export const TaxLocationDecisionsByPricingPlanSelector = TaxLocationDecisionsByPricingPlanHelper([ServiceTaxDecisionsSelector]);

// export const EditPhysicalAttributeGroupsSelector = createSelector(
//     [EditCartSelector],
//     (editCart) => {
//         return editCart.editPhysicalAttributeGroups ? editCart.editPhysicalAttributeGroups.asMutable({
//             deep: true
//         }) : EMPTY_ATTRIBUTE_GROUPS;
//     }
// );

// export const IsCalculatingQuoteSelector = createSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.isCalculatingQuote;
//     }
// );

// export const IsSavingOrderSelector = createSelector(
//     [EditCartSelector],
//     (editCart) => {
//         return editCart.isSavingOrder;
//     }
// );

// export const IsResumingOrderSelector = createSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.isResumingOrder;
//     }
// );

// export const IsResumingStoreOrderSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.isResumingStoreOrder;
//     }
// );

// export const SubscriberPhysicalInventoryPickupDetailSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.subscriberPhysicalInventoryPickupDetail;
//     }
// );

// export const PickupIdSelector = createImmutableSelector(
//     [SubscriberPhysicalInventoryPickupDetailSelector],
//     (subscriberPhysicalInventoryPickupDetail) => {
//         return subscriberPhysicalInventoryPickupDetail.id;
//     }
// );

// export const QuoteCalculatedSelector = createSelector(
//     [AddServicesOrderDataSelector],
//     (addServicesOrderData) => {
//         return addServicesOrderData.quoteCalculated;
//     }
// );

// export const SubTotalSelector = createSelector(
//     [AddServicesOrderDataSelector],
//     (addServicesOrderData) => {
//         return addServicesOrderData.subTotal;
//     }
// );

// export const TaxAmountSelector = createSelector(
//     [AddServicesOrderDataSelector],
//     (addServicesOrderData) => {
//         return addServicesOrderData.taxAmount;
//     }
// );

// export const TotalAmountSelector = createSelector(
//     [AddServicesOrderDataSelector],
//     (addServicesOrderData) => {
//         return addServicesOrderData.totalAmount;
//     }
// );

// const SubscriptionOrderQuoteSelector = createSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return addServicesWizardStore.subscriptionOrderQuote;
//     }
// );

// export const OfferQuoteSelector = GetOfferingOrderQuoteSelector([OfferingOrderQuoteSelector]);

// export const AddOfferQuoteSelector = GetOfferQuoteSelector([AddServicesWizardStoreSelector]);

// export const AvailableCreditFromQuoteBreachedSelector = AvailableCreditFromQuote([OfferQuoteSelector]);

// export const IsCreditLimitBreachedFromQuoteSelector = IsCreditLimitBreachedFromQuote([OfferQuoteSelector]);

// export const OfferQuoteFinanceCreditLimitSelector = OfferingOrderFinanceCreditLimitSelector;

// export const AvailableFinanceCreditFromQuoteSelector = FinanceCreditFromQuoteSelector([OfferQuoteFinanceCreditLimitSelector]);

// export const TotalDownPaymentSelector = GetTotalDownPaymentAmountSelector([AddOfferQuoteSelector]);

// export const SubscriptionDataForPreview = createSelector(
//     [SubscriptionOrderQuoteSelector, OfferQuoteSelector],
//     (subscriptionOrderQuote, offerQuote) => {
//         return SubscriptionQuoteForPreview(subscriptionOrderQuote, offerQuote);
//     }
// );

// export const QuoteHasInvoiceItemsSelector = GetQuoteHasInvoiceItemsSelector([OfferQuoteSelector]);

// export const ValidPaymentInstrument = createSelector(
//     [PaymentInfoSelector, SelectedPaymentMethodSelector],
//     (paymentInfo, selectedPaymentMethod) => {
//         const availablePaymentInfo = paymentInfo || selectedPaymentMethod;
//         return isValidPaymentInstrument(availablePaymentInfo) &&
//         isValidBillingInformation(availablePaymentInfo) ?
//             availablePaymentInfo : null;
//     }
// );

// const MultiOfferingSelector = createSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizardStore) => {
//         return Immutable(addServicesWizardStore.multiOffer);
//     }
// );

// export const OffCycleAlignmentSubscriberProductDataSelector = createImmutableSelector(
//     [MultiOfferingSelector],
//     (multiOffer) => {
//         return multiOffer.offCycleAlignmentSubscriberProductData || EMPTY_OBJECT;
//     }
// );

// export const InitializeAsMultiOfferWizardSelector = createSelector(
//     [MultiOfferingSelector],
//     (multiOffer) => {
//         return Immutable(multiOffer.initializeAsMultiOfferWizard);
//     }
// );

// export const TransferFromSubscriberIdSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addOfferStore) => {
//         return addOfferStore.transferFromSubscriberId;
//     }
// );

// export const TransferFromNameSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addOfferStore) => {
//         return addOfferStore.transferFromName;
//     }
// );

// export const IsTransferWizardSelector = createImmutableSelector(
//     [TransferFromNameSelector],
//     (transferFromName) => {
//         return !!transferFromName;
//     }
// );

// const formatShoppingCartItemsWithBillingEffectiveDate = (shoppingCart, executionOptions, alignmentData) => {
//     return shoppingCart.set('Items', shoppingCart && shoppingCart.Items && shoppingCart.Items.map((item) => {
//         if (alignmentData[item.OfferingInstanceId] && alignmentData[item.OfferingInstanceId][item.PricingPlanId]
//             && alignmentData[item.OfferingInstanceId][item.PricingPlanId].productId === item.ProductId) {
//             return item.set('OffCycleAlignmentSubscriberProductId', alignmentData[item.OfferingInstanceId][item.PricingPlanId].subscriberProductId)
//                 .set('BillingEffectiveDate', executionOptions.billingEffectiveDate)
//                 .set('BillingEffectiveDateIntention', executionOptions.billingEffectiveIntention);
//         }
//         return item.set('BillingEffectiveDate', executionOptions.billingEffectiveDate)
//             .set('BillingEffectiveDateIntention', executionOptions.billingEffectiveIntention)
//             .set('DownPaymentType', GetDownPaymentTypeValue(item));
//     }));
// };

// const formatShoppingCartWithPurchaseOrderNumber = (shoppingCart, purchaseOrderNumber) => {
//     return shoppingCart.set('Items', shoppingCart && shoppingCart.Items && shoppingCart.Items.map((item) => {
//         return purchaseOrderNumber ? item.set('PurchaseOrderNumber', purchaseOrderNumber) : item;
//     }));
// };

// export const MultiOfferShoppingCartSelector = createImmutableSelector(
//     [MultiOfferingSelector, SelectedOrderExecutionOptionsSelector, OffCycleAlignmentSubscriberProductDataSelector, SelectedOfferPurchaseOrderNumberSelector],
//     (multiOffer, executionOptions, offCycleAlignmentSubscriberProductData, purchaseOrderNumber) => {
//         const shoppingCartFormatted = executionOptions && executionOptions.billingEffectiveIntention ?
//             formatShoppingCartItemsWithBillingEffectiveDate(multiOffer.shoppingCart, executionOptions, offCycleAlignmentSubscriberProductData) :
//             multiOffer.shoppingCart;
//         return purchaseOrderNumber ? formatShoppingCartWithPurchaseOrderNumber(shoppingCartFormatted, purchaseOrderNumber) : shoppingCartFormatted;
//     }
// );

// export const IsAddOfferPaymentInstrumentRequiredSelector = createSelector(
//     [
//         PaymentInstrumentRequiredSelector,
//         MultiOfferShoppingCartSelector
//     ],
//     (selectedOfferPaymentInstrumentRequired, multiOfferShoppingCart) => {
//         return Immutable(multiOfferShoppingCart.PaymentInstrumentRequired || selectedOfferPaymentInstrumentRequired);
//     }
// );

// export const HasOffCycleChargeRenewalAddOfferSelector = createImmutableSelector(
//     [
//         HasOffCycleChargeRenewalSelector,
//         MultiOfferShoppingCartSelector
//     ],
//     (hasRenewal, multiOfferShoppingCart) => {
//         return multiOfferShoppingCart.HasOffCycleChargeRenewal || hasRenewal;
//     }
// );

// export const IsRetrievingMultiOfferCartSelector = createSelector(
//     [MultiOfferingSelector],
//     (multiOffer) => {
//         return Immutable(multiOffer.isRetrievingCart);
//     }
// );

// const MultiOfferShoppingCartItemsSelector = createSelector(
//     [MultiOfferShoppingCartSelector],
//     (multiOfferShoppingCart) => {
//         return (multiOfferShoppingCart.Items && multiOfferShoppingCart.Items.length) ? Immutable(multiOfferShoppingCart.Items) : EMPTY_ARRAY;
//     }
// );

// const MultiOfferShoppingCartOfferingsSelector = createImmutableSelector(
//     [MultiOfferShoppingCartSelector],
//     (multiOfferShoppingCart) => {
//         return multiOfferShoppingCart.Offerings || EMPTY_ARRAY;
//     }
// );

// export const IsMultiOfferShoppingCartPrepaidSelector = createSelector(
//     [MultiOfferShoppingCartItemsSelector],
//     (multiOfferShoppingCartItems) => {
//         return Immutable(multiOfferShoppingCartItems.some((item) => {
//             return item.Details.PricingPlan.Prepaid;
//         }));
//     }
// );

// export const RemoveOfferInstanceIdSelector = createSelector(
//     [MultiOfferingSelector],
//     (multiOffer) => {
//         return Immutable(multiOffer.removeOfferingInstanceId);
//     }
// );

// export const ShoppingCartWithoutRemovedOfferSelector = createImmutableSelector(
//     [RemoveOfferInstanceIdSelector, MultiOfferShoppingCartSelector],
//     (removeOfferInstanceId, multiOfferShoppingCart) => {
//         return pathOr(0, ['Items', 'length'], multiOfferShoppingCart) ?
//             multiOfferShoppingCart.setIn(['Items'], multiOfferShoppingCart.Items.filter((cartItem) => {
//                 return cartItem.OfferingInstanceId !== removeOfferInstanceId;
//             })): multiOfferShoppingCart;
//     }
// );

// export const IsRemovingOfferSavedToMultiOfferCartSelector = createImmutableSelector(
//     [RemoveOfferInstanceIdSelector, MultiOfferShoppingCartItemsSelector],
//     (removeOfferInstanceId, multiOfferCartItems) => {
//         return !removeOfferInstanceId ? false : !!multiOfferCartItems.filter((cartItem) => {
//             return cartItem.OfferingInstanceId === removeOfferInstanceId;
//         }).length;
//     });

// export const SelectedOfferingInstanceIdSelector = createSelector(
//     [MultiOfferingSelector],
//     (multiOffer) => {
//         return Immutable(multiOffer.selectedOfferingInstanceId || undefined);
//     }
// );

// const OfferInstanceIdsSelector = createImmutableSelector(
//     [MultiOfferShoppingCartItemsSelector],
//     (offerShoppingCartItems) => {
//         return uniq(pluck('OfferingInstanceId', filter((item) => {
//             return !!item.OfferingInstanceId;
//         }, offerShoppingCartItems)));
//     }
// );

// export const AddOfferAsyncIdSelector = createImmutableSelector(
//     [AddServicesWizardStoreSelector],
//     (addServicesWizard) => {
//         return addServicesWizard.asyncId;
//     }
// );

// export const IsAsyncCompleteSelector  = createImmutableSelector(
//     [
//         AddOfferAsyncIdSelector,
//         AsyncStatusSelector,
//     ],
//     (asyncId, asyncStatus) => {
//         return asyncId ?
//             asyncStatus === ASYNC_STATUS_CONSTANTS.COMPLETE || asyncStatus === ASYNC_STATUS_CONSTANTS.FAILED :
//             true;
//     }
// );

// export const IsFullCartAsyncCompleteSelector  = createImmutableSelector(
//     [
//         AddOfferAsyncIdSelector,
//         FullCartAsyncStatusSelector,
//     ],
//     (asyncId, fullCartAsyncStatus) => {
//         return asyncId ? fullCartAsyncStatus === ASYNC_STATUS_CONSTANTS.COMPLETE || fullCartAsyncStatus === ASYNC_STATUS_CONSTANTS.FAILED : true;
//     }
// );

// export const OffersCountSelector = createSelector(
//     [OfferInstanceIdsSelector],
//     (offerInstanceIds) => {
//         return Immutable(offerInstanceIds.length);
//     }
// );

// export const IsMultiOfferSelector = createSelector(
//     [OffersCountSelector],
//     (offerCount) => {
//         return Immutable(!!offerCount);
//     }
// );

// export const MultiOfferIdsSelector = createImmutableSelector(
//     [MultiOfferShoppingCartItemsSelector],
//     (multiOfferItems) => {
//         return uniq(pluck('OfferingId', multiOfferItems)).filter((value) => {
//             return value;
//         });
//     }
// );

// export const IsMultiOfferEditingSelector = createImmutableSelector(
//     [SelectedOfferingInstanceIdSelector],
//     (selectedOfferingInstanceId) => {
//         return !!selectedOfferingInstanceId;
//     }
// );

// export const EditedMultiOfferShoppingCartSelector = createImmutableSelector(
//     [ShoppingCartSelector, MultiOfferShoppingCartSelector, MultiOfferShoppingCartItemsSelector, SelectedOfferingInstanceIdSelector, ChangeOfferingInstanceIdSelector],
//     (shoppingCart, multiOfferShoppingCart, multiOfferShoppingCartItems, selectedOfferingInstanceId, changeOfferingInstanceId) => {
//         const cartItemsWithoutSelectedOfferingInstance = multiOfferShoppingCartItems.filter((cartItems) => {
//             return cartItems.OfferingInstanceId !== (changeOfferingInstanceId ? changeOfferingInstanceId : selectedOfferingInstanceId);
//         });
//         const editedMultiOfferShoppingCart = [...cartItemsWithoutSelectedOfferingInstance];
//         editedMultiOfferShoppingCart.push(...(shoppingCart.Items || []).map((item) => {
//             return Object.assign({}, item, {
//                 OfferingInstanceId: changeOfferingInstanceId || selectedOfferingInstanceId
//             });
//         }));
//         return multiOfferShoppingCart.setIn(['Items'], editedMultiOfferShoppingCart);
//     }
// );

// export const MultiOfferShoppingCartPhysicalInventoryItemsSelector = createImmutableSelector(
//     [
//         MultiOfferShoppingCartSelector,
//         IsMultiOfferEditingSelector,
//         ChangeOfferingInstanceIdSelector,
//         EditedMultiOfferShoppingCartSelector
//     ],
//     (multiOfferShoppingCart, isMultiOfferEditing, changeOfferingInstanceId, editedMultiOfferShoppingCart) => {
//         const shoppingCart = isMultiOfferEditing || changeOfferingInstanceId ? editedMultiOfferShoppingCart : multiOfferShoppingCart;

//         return pathOr(EMPTY_ARRAY, ['Items'], shoppingCart).filter((item) => {
//             return item.PhysicalInventories && item.PhysicalInventories.length;
//         });
//     }
// );

// export const AddOfferShoppingCartPhysicalInventoriesSelector = createImmutableSelector(
//     [
//         MultiOfferShoppingCartPhysicalInventoryItemsSelector,
//         SelectedOfferingPhysicalInventoriesSelector,
//         IsMultiOfferEditingSelector,
//         ChangeOfferingInstanceIdSelector
//     ],
//     (multiOfferShoppingCartPhysicalInventoryItems, selectedOfferingPhysicalInventoryItems, isMultiOfferEditing, changeOfferingInstanceId) => {
//         return isMultiOfferEditing || changeOfferingInstanceId ?
//             multiOfferShoppingCartPhysicalInventoryItems :
//             [...multiOfferShoppingCartPhysicalInventoryItems, ...selectedOfferingPhysicalInventoryItems];
//     }
// );

// export const AllPhysicalInventoryItemsFromAddOfferSelector = createImmutableSelector(
//     [AddOfferShoppingCartPhysicalInventoriesSelector],
//     (shoppingCartPhysicalInventoryItems) => {
//         const shoppingCartItemsWithPhysicalInventories = shoppingCartPhysicalInventoryItems.filter((items) => {
//             return items.PhysicalInventories;
//         });
//         return flatten(pluck('PhysicalInventories', shoppingCartItemsWithPhysicalInventories)).map((item, index) => {
//             return {
//                 DisplayName: item.DisplayName,
//                 InstanceId: generateKeyFromInventoryItem(item, index),
//                 InventoryAttributes: item.InventoryAttributes,
//                 InventoryTypeId: item.InventoryTypeId,
//                 MakeId: item.MakeId,
//                 ModelId: item.ModelId,
//                 Quantity: 1
//             };
//         });
//     }
// );

// export const AddOfferSubscriberInventoryAvailabilityInventorySelector = createImmutableSelector(
//     [
//         AllPhysicalInventoryItemsFromAddOfferSelector,
//         SelectedInventoryRegionSelector,
//         InventoryRegionFilterSelector
//     ],
//     (allPhysicalInventoryItemsFromAddOffer, selectedRegionFromCurrentlySelectedStore, currentlySelectedRegion) => {
//         return !allPhysicalInventoryItemsFromAddOffer || !selectedRegionFromCurrentlySelectedStore ? null :
//             {
//                 InventoryTypes: allPhysicalInventoryItemsFromAddOffer,
//                 RegionId: currentlySelectedRegion ? currentlySelectedRegion : selectedRegionFromCurrentlySelectedStore,
//             };
//     }
// );

// export const SelectedOfferIndexSelector = createImmutableSelector(
//     [OfferInstanceIdsSelector, SelectedOfferingInstanceIdSelector, OffersCountSelector, ChangeOfferingInstanceIdSelector],
//     (offeringInstanceIds, selectedOfferInstanceId, offersCount, changeOfferingInstanceId) => {
//         return changeOfferingInstanceId || selectedOfferInstanceId ?
//             clone(offeringInstanceIds).sort().indexOf(changeOfferingInstanceId || selectedOfferInstanceId) + 1 :
//             offersCount;
//     }
// );

// export const AddedOffersSelector = createImmutableSelector(
//     [
//         MultiOfferShoppingCartItemsSelector,
//         MultiOfferShoppingCartOfferingsSelector,
//         MetadataCodeTypeDictionarySelector(CODES.RegularExpression),
//         MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute),
//         IsTransferWizardSelector,
//     ],
//     (offerShoppingCartItems, multiOfferShoppingCartOfferings, regularExpressionCodeTable, serviceAttributeCodeTable, isTransferWizard) => {
//         return sortBy(prop('id'), (offerShoppingCartItems).reduce((accumulator, cartItem) => {
//             const offerInstanceIds = pluck('id', accumulator);
//             if (!offerInstanceIds.length || !offerInstanceIds.includes(cartItem.OfferingInstanceId)) {
//                 const offering = multiOfferShoppingCartOfferings.find((offer) => {
//                     return offer.OfferingId === cartItem.OfferingId;
//                 });
//                 const cartItemsForOfferingInstanceId = offerShoppingCartItems.filter((item) => {
//                     return item.OfferingInstanceId === cartItem.OfferingInstanceId;
//                 });
//                 const serviceAttributes = compose(flatten, pluck('ServiceAttributes'))(cartItemsForOfferingInstanceId);
//                 accumulator.push({
//                     id: cartItem.OfferingInstanceId,
//                     isChangeable: offering && !isTransferWizard ? offering.IsChangeable : false,
//                     name: cartItem.OrderedOfferingName,
//                     offeringId: cartItem.OfferingId,
//                     serviceIdentifiers: getUniqueNonGuidServiceIdentifiers(serviceAttributes, serviceAttributeCodeTable, regularExpressionCodeTable),
//                 });
//             }
//             return accumulator;
//         }, []));
//     }
// );

// export const MultiOfferEditingShoppingCartItems = createImmutableSelector(
//     [
//         MultiOfferShoppingCartItemsSelector,
//         IsMultiOfferEditingSelector,
//         SelectedOfferingPhysicalInventoriesSelector
//     ],
//     (multiOfferCartItems, isMultiOfferEditing, selectedOfferingPhysicalInventoryItem) => {
//         const multiOfferShoppingCartItems = isMultiOfferEditing ? multiOfferCartItems.filter((item) => {
//             return selectedOfferingPhysicalInventoryItem.some((inventoryItems) => {
//                 return item.PricingPlanId !== inventoryItems.PricingPlanId;
//             });
//         }) : EMPTY_ARRAY;
//         return [...multiOfferShoppingCartItems, ...selectedOfferingPhysicalInventoryItem];
//     }
// );

export var IsDecisionsTouchedSelector = createSelector([AddServicesWizardStoreSelector], function (addServicesWizardStore) {
  return Immutable(!!addServicesWizardStore.isDecisionsTouched);
});

// export const MultiOfferFinancedItemsForDownpaymentSelector = createImmutableSelector(
//     [MultiOfferShoppingCartSelector, OfferQuoteSelector],
//     (multiOfferShoppingCart, offerQuote) => {
//         // The multi offer financeItems is handled differently than a single offer which creates the need for 2 selectors.

//         return getFinanceItems(multiOfferShoppingCart).map((item) => {
//             const quoteItem = pathOr([], ['Items'], offerQuote).find((quoteItem) => {
//                 return (quoteItem.PricingPlan.Id === item.PricingPlanId
//                     && quoteItem.Product.Id === item.ProductId);
//             });
//             const financeBillerRuleInstance = pathOr(0, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances',
//                 'FinanceBillerRuleInstances', '0'], item);
//             return {
//                 billerRule: item.Details.PricingPlan.BillerRuleInstanceThumbnails[0],
//                 currencyCode: item.Details.PricingPlan.Currency,
//                 downPayment: item.downPayment || financeBillerRuleInstance.MinimumDownPaymentAmount,
//                 downPaymentType: item.DownPaymentType || undefined,
//                 financedFullAmount: pathOr(0, ['FinancedFullAmount'], quoteItem),
//                 grossAmount: item.Details.PricingPlan.BillerRuleInstanceThumbnails[0].Amount,
//                 id: item.Id,
//                 inventoryAttributes: pathOr([], ['PhysicalInventories', 0, 'InventoryAttributes'], item),
//                 isDownPaymentEqualToFirstInstallment: financeBillerRuleInstance.DownPaymentEqualToFirstInstallment,
//                 isDownPaymentEqualToFirstSelected: !item.isFullPriceDownPaymentSelected,
//                 isFullPriceDownPaymentSelected: item.isFullPriceDownPaymentSelected || false,
//                 isFullUpfrontPayment: financeBillerRuleInstance.FullUpfrontPayment,
//                 itemIndex: item.itemIndex,
//                 minimumDownPayment: financeBillerRuleInstance.MinimumDownPaymentAmount,
//                 name: item.Details.Product.Name,
//                 payPerAmount: pathOr(0, ['Amount'], quoteItem),
//                 pricingPlanId: item.Details.PricingPlan.Id,
//                 pricingPlanName: item.Details.PricingPlan.Name,
//                 productId: item.Details.Product.Id,
//                 taxAmount: pathOr(0, ['TaxAmount'], quoteItem),
//                 termLength: financeBillerRuleInstance.TermLength
//             };
//         });
//     }
// );

// export const AddOfferStoreAvailabilitySelector = createImmutableSelector(
//     [
//         InventoryAvailabilitySelector,
//         FilteredStoresOnSelectedRegionForStoresSearchModalSelector,
//         AllPhysicalInventoryItemsFromAddOfferSelector],
//     (availableInventoryForStores, stores, allPhysicalInventoryItemsFromAddOffering) => {
//         let areRegionsInSync = false;
//         if (availableInventoryForStores && stores) {
//             areRegionsInSync = availableInventoryForStores && availableInventoryForStores[0] && stores ? stores.find((store) => {
//                 return store.storeId === availableInventoryForStores[0].StoreId;
//             }) : false;
//         }

//         if (availableInventoryForStores && allPhysicalInventoryItemsFromAddOffering && stores && areRegionsInSync) {
//             return allPhysicalInventoryItemsFromAddOffering.map((inventoryItem) => {
//                 const storeAvailForInventoryItem = [];
//                 stores.forEach((store) => {
//                     const itemAvailabilityAtStoreResponse = availableInventoryForStores.find((inventoryStatusAtStore) => {
//                         return inventoryStatusAtStore.InstanceId === inventoryItem.InstanceId &&
//                             inventoryStatusAtStore.StoreId === store.storeId;
//                     });

//                     if (itemAvailabilityAtStoreResponse) {
//                         storeAvailForInventoryItem.push({
//                             storeId: store.storeId,
//                             AvailableUnits: itemAvailabilityAtStoreResponse.AvailableUnits,
//                             RequestedQuantity: itemAvailabilityAtStoreResponse.RequestedQuantity,
//                             MeetsRequestedQuantity: itemAvailabilityAtStoreResponse.MeetsRequestedQuantity
//                         });
//                     }
//                 });
//                 return {
//                     DisplayName: inventoryItem.DisplayName,
//                     InstanceId: inventoryItem.InstanceId,
//                     InventoryAttributes: inventoryItem.InventoryAttributes,
//                     InventoryTypeId: inventoryItem.InventoryTypeId,
//                     MakeId: inventoryItem.MakeId,
//                     ModelId: inventoryItem.ModelId,
//                     Quantity: 1,
//                     stores: storeAvailForInventoryItem
//                 };
//             });
//         }
//         return [];
//     }
// );

// export const PostQuoteDueTotalsSelector = GetPostQuoteDueTotalsSelector([OfferQuoteSelector]);

// export const PreQuoteDueSubTotalsSelector = GetPreQuoteDueSubTotalsSelector([ShoppingCartSelector]);

// export const CartAdditionalPropertiesSelector = GetCartAdditionalPropertiesSelector([AddServicesWizardStoreSelector]);

// export const CartAdditionalPropertyListMapSelector = GetAdditionalPropertyListMapSelector([CartAdditionalPropertiesSelector, CartAdditionalPropertyFieldsSelector]);

export var OrderAdditionalPropertiesSelector = GetOrderAdditionalPropertiesSelector([AddServicesWizardStoreSelector]);
export var OfferAdditionalPropertiesSelector = GetOfferAdditionalPropertiesSelector([AddServicesWizardStoreSelector]);
export var OrderAdditionalPropertyListMapSelector = GetAdditionalPropertyListMapSelector([OrderAdditionalPropertiesSelector, OrderAdditionalPropertyFieldsSelector]);
export var OfferAdditionalPropertyListMapSelector = GetAdditionalPropertyListMapSelector([OfferAdditionalPropertiesSelector, OfferAdditionalPropertyFieldsSelector]);
// export const MultiOfferCartContainsOfferWithBillerRuleCycleLevelOtherThanItemSelector = createImmutableSelector(
//     [MultiOfferIdsSelector, OfferingMetadataByIdSelector],
//     (multiOfferIds, offeringMetadataById) => {
//         return (multiOfferIds || []).some((offerId) => {
//             return (offeringMetadataById[offerId] || {}).BillerRuleCycleLevel !== BILLER_RULE_CYCLE_LEVEL.ITEM;
//         });
//     });

// export const MultiOfferCartContainsOfferWithAtleastOneBillerRuleCycleLevelAsItemSelector = createImmutableSelector(
//     [MultiOfferIdsSelector, OfferingMetadataByIdSelector],
//     (multiOfferIds, offeringMetadataById) => {
//         return (multiOfferIds || []).some((offerId) => {
//             return (offeringMetadataById[offerId] || {}).BillerRuleCycleLevel === BILLER_RULE_CYCLE_LEVEL.ITEM;
//         });
//     });

// export const AddOfferOffCycleAlignmentOptionsSelector = OfferingOrderOffCycleAlignmentOptionsSelector([MultiOfferShoppingCartSelector,
//     OfferingMetadataByIdSelector,
//     OfferingOrderOffCycleAlignmentSelector,
//     MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute),
//     MetadataCodeTypeDictionarySelector(CODES.RegularExpression)]);

// export const AddOfferProductIdsAndPricingPlanIdsOffCycleOfferSelector = OfferingOrderProductIdsAndPricingPlanIdsOffCycleOfferSelector([MultiOfferShoppingCartSelector,
//     OfferingMetadataByIdSelector]);

// export const AddOfferSelectedOffCycleAlignmentsSelector = SelectedOffCycleAlignmentsSelector([OffCycleAlignmentSubscriberProductDataSelector,
//     AddOfferOffCycleAlignmentOptionsSelector]);

// export const ShippingAddressSelector = ShippingAddressWizardSelector([OfferingOrderDataSelector]);

// export const AddServicesDeliveryMethodOptionsSelector = DeliveryMethodOptionsSelector([ShippingMethodsSelector, CurrentCustomerCurrencyCodeSelector]);